import React from "react";
import "./OceShaCreatorTestimonials.css";

import errolImg from "../assets/ocesha_images/creator_testimonials/errol-chung.png";
import joanImg from "../assets/ocesha_images/creator_testimonials/joan-chepkwony.png";

interface OceShaCreatorTestimonialsProps {
  onStartFreeClick?: () => void;
}

const OceShaCreatorTestimonials: React.FC<
  OceShaCreatorTestimonialsProps
> = ({ onStartFreeClick }) => {
  return (
    <section
      className="occreator-section"
      aria-labelledby="occreator-heading"
    >
      <div className="occreator-card">
        <div className="occreator-content">

          {/* Badge */}
          <div className="occreator-eyebrow">
            <span className="occreator-eyebrow-icon">▣</span>
            TRUSTED BY COURSE CREATORS
          </div>

          {/* Heading */}
          <h2
            id="occreator-heading"
            className="occreator-h2"
          >
            Loved by{" "}
            <span className="occreator-gradient">
              Course Creators.
            </span>
          </h2>

          {/* Subtitle */}
          <p className="occreator-intro">
            Real people. Real results. Real impact.
          </p>

          {/* Testimonials */}
          <div className="occreator-grid">

            {/* =================================================
                ERROL CHUNG
                ================================================= */}
            <article className="occreator-testimonial occreator-errol">

              <div
                className="occreator-decoration occreator-errol-decoration"
                aria-hidden="true"
              />

              <div className="occreator-heart" aria-hidden="true">
                ♡
              </div>

              <div
                className="occreator-quote-mark"
                aria-hidden="true"
              >
                “
              </div>

              <blockquote>
                “I’ve created courses before,
                <br />
                and this is amazing. I love
                <br />
                the idea of the courses
                <br />
                because I can actually
                <br />
                monetize it.”
              </blockquote>

              <div className="occreator-person">
                <div className="occreator-avatar">
                  <img
                    src={errolImg}
                    alt="Errol Chung"
                  />
                </div>

                <div className="occreator-person-info">
                  <strong>Errol Chung</strong>
                  <span>Content Creator</span>
                </div>
              </div>

            </article>


            {/* =================================================
                JOAN CHEPKWONY
                ================================================= */}
            <article className="occreator-testimonial occreator-joan">

              <div
                className="occreator-dot-pattern occreator-dot-top"
                aria-hidden="true"
              />

              <div
                className="occreator-dot-pattern occreator-dot-bottom"
                aria-hidden="true"
              />

              <div className="occreator-globe" aria-hidden="true">
                ◉
              </div>

              <div
                className="occreator-quote-mark"
                aria-hidden="true"
              >
                “
              </div>

              <blockquote>
                “It’s great that we can
                <br />
                teach AI Literacy to
                <br />
                students and teachers
                <br />
                in Africa in English and
                <br />
                Swahili with OceSha”
              </blockquote>

              <div className="occreator-person">
                <div className="occreator-avatar">
                  <img
                    src={joanImg}
                    alt="Joan Chepkowy"
                  />
                </div>

                <div className="occreator-person-info">
                  <strong>Joan Chepkowy</strong>
                  <span>AI Sprouts</span>
                </div>
              </div>

            </article>

          </div>

          

        </div>

        
      </div>
      {/* Existing Start Free CTA */}
          <div className="ocesha-occreator-section__action">
            <button
              className="ocesha-idea-section__button"
              type="button"
              onClick={onStartFreeClick}
            >
              Start Free
              
            </button>
          </div>
    </section>
  );
};

export default OceShaCreatorTestimonials;